// The Generic Paddlewheel reading is an unsigned 12-bit integer-with-multiplier value indicating the average time between pulses. This value is first converted to frequency and then converted to volume rate in US gallons per minute. The ConversionFormulaScale and ConversionFormulaOffset parameters are used to convert frequency to volume rate. The rate is then converted to cubic meters per second and a volume reading is then created in cubic meters. Convert the 12-bit value ($rdg in code below) to volume rate ($rate in code below) and then to volume ($vol in code below) using the following algorithm:

/*
$rate = 0.0;
if ( $rdg == 0xFFF )
{
  $rate = null; // display reading as “invalid”
} else {
  $scale = 0.0;

  $cnt = ((int)$rdg) >> 2;
  $mult =  ((int)$rdg) & 0x03;

  switch ( $mult )
  {
    case 0: $scale = 0.1E-3; break;
    case 1: $scale = 0.4E-3; break;
    case 2: $scale = 1.6E-3; break;
    case 3: $scale = 6.4E-3; break;
  }

  $dt = ($cnt * $scale);

  if ($dt > 0.0) {
    $kfactor = (float)$ConversionFormulaScale;
    $offset = (float)$ConversionFormulaOffset;
    $freq = 1.0 / $dt;

    // volume in gallons/minute
    $gpm = ($freq + $offset) * $kfactor;
    if ($gpm > 0.0 ) {
      $rate = $this->ConvertDispToBase($gpm);
    }
  }
}

$vol = 0.0;

if ( $rdg == 0xFFF ) {
  $vol = null; // display reading as “invalid”
} else {
// schedule frequency is in minutes
  $sts = $this->GetStatusFlags();
  if (((int)$sts) & 0x04) {
      $sf = 1; // this is an INIT reading taken every 1 minute
  } else {
    $sf = $this->GetScheduleFrequency();
  }

  $vol = ($sf * $rate) * 60.0;
}
*/

export function paddlewheel(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  var rate = 0.0
  var scale = 0.0

  const cnt = reading >> 2
  const mult = reading & 0x03

  switch (mult) {
    case 0:
      scale = 0.1e-3
      break
    case 1:
      scale = 0.4e-3
      break
    case 2:
      scale = 1.6e-3
      break
    case 3:
      scale = 6.4e-3
      break
  }

  const dt = cnt * scale

  if (dt > 0.0) {
    const kfactor = scale
    const freq = 1.0 / dt

    // volume in gallons/minute
    const gpm = (freq + offset) * kfactor
    if (gpm > 0.0) {
      // TODO: figure out when is best to convert this (I think it's outside this function)
      // rate = this->ConvertDispToBase(gpm);
    }
  }

  // schedule frequency is in minutes
  // const sts = this->GetStatusFlags();
  const sts = 0x44
  var sf = 1 // this is an INIT reading taken every 1 minute
  if (!(sts & 0x04)) {
    // TODO: figure out when is best to convert this (I think it's outside this function)
    // sf = this->GetScheduleFrequency();
  }

  return sf * rate * 60.0
}
